module.exports = __webpack_public_path__ + "static/img/icon8-5.83ded68d.png";